import ManagersRoot from './ManagersRoot';
import ManagersEdit from './ManagersEdit';
import ManagersNew from './ManagersNew';

export default {
  path: 'managers',
  component: ManagersRoot,
  childRoutes: [
    // new item
    { path: 'new', component: ManagersNew },
    // edit item,
    { path: 'edit/:id', component: ManagersEdit }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Managers/router.js